// extracted by mini-css-extract-plugin
export default {"single-item":"accordian_single-item__gH+5w"};